// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'

// Vue.config.productionTip = false;

Vue.component('navmain',
  require('./components/modules/navmain.vue')
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js